<template>
    <div>
        <div class="pt-3 mb-3">
            <div class="container">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex">
                        <h5 class="m-0 p-0 align-self-center">
                            Melhorias
                        </h5>
                    </div>
                    <div class="d-flex gap-2 align-items-center">
                        <b-form-input
                            v-model="filter.search"
                            placeholder="Buscar..."
                            debounce="500"
                        ></b-form-input>
                        <b-button type="button" block variant="primary" class="" @click="createPost">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>

                            Nova Solicitação
                        </b-button>
                    </div>

                </div>
            </div>
        </div>
        <div class="container">
            <b-card>

                <b-overlay :show="loading">
                    <b-table
                        id="improvementsTable"
                        :items="solicitations.items"
                        :fields="fields"
                        show-empty
                        empty-text="Não encontramos nenhum resultado na busca :("
                        no-local-sorting

                    >
                    <template v-slot:cell(title)="row">
                        <show-post :postItem="row.item" :categories-data="categories">
                            <template v-slot:description>
                                <div class="text-black-50 fw-normal mb-3" >
                                    {{ short(row.item.description) }}
                                    <span role="button" class="btn btn-link" @click="showPost(row.item)">Ver mais</span>
                                </div>
                            </template>
                        </show-post>
                    </template>

                    </b-table>


                </b-overlay>

                <nav aria-label="Page navigation example">
                    <ul class="pagination">
                      <li class="page-item">
                        <button class="page-link" :disabled="currentPage===0" @click="changePagination('back')" aria-label="Anterior">
                          <span aria-hidden="true">&laquo;</span>
                        </button>
                      </li>
                      <li class="page-item active"><span class="page-link" href="#">{{currentPage +1 }}</span></li>
                      <li class="page-item">
                        <a class="page-link" v-if="solicitations.has_more" @click="changePagination('continue')" aria-label="Próxima">
                          <span aria-hidden="true">&raquo;</span>
                        </a>
                      </li>
                    </ul>
                </nav>
            </b-card>
        </div>
        <post-modal :postData="postData"></post-modal>
        <create-post @created="load"></create-post>
    </div>
</template>

<script>
import PostModal from './FullPostModal.vue';
import CreatePost from './CreatePostModal.vue';
import showPost from './Post.vue';
export default {
    components: {
        showPost,
        PostModal,
        CreatePost
    },
    data(){
        return {
            loading: false,
            solicitations: [],
            categories: {},
            fields: [
                { key: 'title', label: 'Solicitações'}
            ],
            currentPage: 0,
            filter: {
                search: null,
                sort: 'new',
            },
            postData: {}
        }
    },
    created(){

        this.load();

    },
    watch: {
        'filter.search': async function (value) {
            this.filter.search = await value;
            this.currentPage = await 0
            await this.load()
        },
    },
    methods: {
        short(string, size = 200) {
            if (string.length > size)
                return string.substring(0, size) + '...'

            return string
        },
        async showPost(item){
            this.postData = await {...item, categories : this.categories}
            this.$root.$emit('ImprovementPost');
        },
        createPost(){
            this.$root.$emit('ImprovementCreate');
        },

        async load() {
            this.loading = true
            this.solicitations = []; 
            await axios.get('/teacher/solicitation', {
                params: {
                    page: this.currentPage,
                    search: this.filter.search,
                    sort: this.filter.sort
                }
            })
            .then((result) => {
                const response = result.data.data.solicitations;


                this.solicitations = response;
                this.currentPage = response.page;
                this.getCategory();


            }).catch((err) => {

            })
            .finally(()=>{
                this.loading = false
            })
        },
        getCategory (){

            axios.get('/teacher/sleekplan/category')
            .then((result) => {
                const response = result.data.data[0]
                this.categories = response;


            })
        },

        async changePagination (action){

            this.currentPage = await action === 'continue' ? this.currentPage+=1 : this.currentPage-=1;

            await this.load()
        }
    }
}
</script>

<style>

</style>

